<template>
  <div
    v-tooltip="'Click to get list of apps'"
    class="apps-type-card"
    @click="handleClick"
  >
    <div class="apps-type-card__header">
      <h3 class="apps-type-card__title">{{ capitalizedType }}</h3>
    </div>

    <p v-if="appType.description" class="apps-type-card__description">{{ appType.description }}</p>

    <div class="apps-type-card__stats">
      <div class="apps-type-card__stat">
        <span class="apps-type-card__stat-label">Apps</span>
        <span class="apps-type-card__stat-value">{{ appType.count }}</span>
      </div>
      <div class="apps-type-card__stat">
        <span class="apps-type-card__stat-label">Free</span>
        <span class="apps-type-card__stat-value apps-type-card__stat-value--free">{{ appType.free ?? 0 }}</span>
      </div>
    </div>

    <div v-if="appType.authors && appType.authors.length > 0" class="apps-type-card__authors">
      <label class="apps-type-card__authors-label" :for="`authors-${appType.type}`">Author</label>
      <div class="apps-type-card__authors-row">
        <select
          :id="`authors-${appType.type}`"
          v-model="selectedAuthor"
          class="apps-type-card__authors-select"
          @click.stop
          @change.stop="applyAuthorFilter"
        >
          <option value="">All authors</option>
          <option v-for="(author, i) in appType.authors" :key="i" :value="author">
            {{ author }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import SVGIcon from '@/components/SVGIcon.vue';

const props = defineProps({
  appType: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['filter']);

const selectedAuthor = ref('');

const capitalizedType = computed(() => {
  const t = String(props.appType.type || '');
  return t.charAt(0).toUpperCase() + t.slice(1);
});

function handleClick() {
  emit('filter', { type: props.appType.type, author: null });
}

function applyAuthorFilter() {
  emit('filter', { type: props.appType.type, author: selectedAuthor.value || null });
}
</script>

<style lang="scss" scoped>
.apps-type-card {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 8px 16px 14px;
  border-radius: 8px;
  width: 300px;
  height: 200px;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
  @include themify() {
    background: #ffffff;
    border: 1px solid #d5dbe6;
    color: #2f2f2f;
  }

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

.apps-type-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.apps-type-card__title {
  font-size: 1rem;
  font-weight: 700;
  margin: 0;
}

.apps-type-card__description {
  font-size: 0.78rem;
  line-height: 1.5;
  margin: 0 0 14px 0;
  font-style: italic;
  color: rgb(12, 59, 99);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.apps-type-card__stats {
  display: flex;
  gap: 16px;
  margin-top: auto;
}

.apps-type-card__stat {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.apps-type-card__stat-label {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  @include themify() {
    color: #888;
  }
}

.apps-type-card__stat-value {
  font-size: 1.1rem;
  font-weight: 700;

  &--free {
    @include themify() {
      color: #16a34a;
    }
  }
}

.apps-type-card__authors {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.apps-type-card__authors-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.apps-type-card__authors-label {
  font-size: 0.72rem;
  font-weight: 600;
  @include themify() {
    color: #666;
  }
}

.apps-type-card__authors-select {
  flex: 1;
  min-width: 0;
  height: 30px;
  padding: 0 8px;
  border-radius: 4px;
  font-size: 0.78rem;
  @include themify() {
    border: 1px solid #d0d0d0;
    background: #f8f8f8;
    color: #333;
  }
}

.apps-type-card__author-apply {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  @include themify() {
    background: #250E81;
    color: #ffffff;
  }
  &:hover {
    opacity: 0.85;
  }
}
</style>
